export default __webpack_public_path__ + "static/media/Active-Income-Brochure.2cb4224b.pdf";